module.exports = __webpack_public_path__ + "static/media/RI_map@2x.b82dfabf.png";